export default {
      id: "dropdown-usage",
      viewBox: "0 0 14 8",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#dropdown",
      toString: function () {
        return this.url;
      }
    }